import { BenefitsForm } from "./BenefitsForm";

const EditBenefit = () => {
  return <BenefitsForm edit />;
};
export { EditBenefit };
